<a routerLink="/custodian/home" routerLinkActive="active" id="custodian_home" [attr.aria-current]="isActive('/custodian/home') ? 'page' : 'false'">
  <i class="fas fa-house"></i>
  <span>{{'Home' | translate}}</span>
</a>
<a routerLink="/custodian/requests" routerLinkActive="active" id="custodian_requests" [attr.aria-current]="isActive('/custodian/requests') ? 'page' : 'false'">
  <i class="fas fa-inbox"></i>
  <span>{{'Requests' | translate}}</span>
</a>
